import { render } from "./BadgeSuccess.vue?vue&type=template&id=d5ee75b8"
import script from "./BadgeSuccess.vue?vue&type=script&lang=js"
export * from "./BadgeSuccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__